import { AppId, Route, createPageRoute } from '@lumapps/router';

export const agentsAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/agents',
    id: 'agents-analytics',
    appId: AppId.backOffice,
});

const agentAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/agents/:id',
    id: 'agent-analytics',
    appId: AppId.backOffice,
});

export const getAgentAnalyticsRoute = (agentId: string): Route => ({
    ...agentAnalyticsRoute,
    params: { id: agentId },
});
